import { useAvatarProfile } from "@/hooks/useAvatarProfile";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { cn } from "@/lib/utils";

interface AvatarProfileProps {
  className?: string;
}

const AvatarProfile = ({ className }: AvatarProfileProps) => {
  const { firstLetter } = useAvatarProfile();
  return (
    <Avatar className={cn("h-6 w-6 bg-primary text-xs", className)}>
      <AvatarFallback className="bg-primary font-medium text-primary-foreground">
        {firstLetter}
      </AvatarFallback>
    </Avatar>
  );
};
export default AvatarProfile;
